import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { VesselFormComponent } from '../vessel-form/vessel-form.component';
import { IVesselCriteria, IVessel } from '../vessel.interface';
import * as _ from 'underscore';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-vessel-view',
    templateUrl: './vessel-view.component.html',
    styleUrls: ['./vessel-view.component.less'],
    standalone: false
})
export class VesselViewComponent implements OnInit,AfterViewInit, OnDestroy {

	vesselForm: FormGroup;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
  	criteria: IVesselCriteria = {};
	pageSizeOptions:Array<number>=this.utilityService.getPageSizeOptions();
	addPermission : boolean = false;
	viewPermission : boolean = false;
	editPermission : boolean = false;
	statusTypes:any=[];
	totalVesselRecords:any;
	groupColumns=['name','operatorName','status','action'];
	vesselDataSource = new MatTableDataSource<IVessel>();
	subscription = new Subscription();
  
  constructor(private service: DataService, private formBuiler: FormBuilder, private dialog: MatDialog,
    private utilityService:UtilityService,private permissionService:PermissionService,private logger:NGXLogger) { }

ngOnInit(): void{	
  this.checkAllPermission();
  this.initializeForm();
  this.getVessels()
  this.operatorNameValueChangeEvent();
  this.nameValueChangeEvent();
  this.setStatusTypeChangeEvent();
  this.getStatusTypes();
}

ngAfterViewInit() {
  this.vesselDataSource.paginator = this.paginator;
  this.vesselDataSource.sort = this.sort;
  this.paginator?.page?.pipe(tap(() => this.getVessels())).subscribe();
		this.getVessels();
}

ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

sortData(event: { active: string; direction: string; }){
	this.criteria.sort = [event.active, event.direction];
	this.getVessels(true);
}

operatorNameValueChangeEvent(){
	this.subscription = this.vesselForm.get('operator').valueChanges.subscribe(operatorName => {
		this.criteria.containsOperatorName=operatorName;
		this.getVessels(true);
    })
}

nameValueChangeEvent(){
	const sub = this.vesselForm.get('name').valueChanges.subscribe(vesselName => {
		this.criteria['name.contains']=vesselName;
		this.getVessels(true);
	});
	this.subscription.add(sub);
}

setStatusTypeChangeEvent(){
	const sub = this.vesselForm.get('status').valueChanges.subscribe(status => {
		this.criteria.status=status;
		this.getVessels(true);
	});
	this.subscription.add(sub);
}

private initializeForm(){
	this.vesselForm = this.formBuiler.group({
		name: [null],
		operator: [null],
		status:[null],
	});
}

private getVessels(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
	if(this.viewPermission){
		this.criteria.sort=this.criteria.sort?.length === undefined ? ['createdDate','desc']:this.criteria.sort;
		this.criteria.page=this.paginator?.pageIndex;
        this.criteria.size=this.paginator?.pageSize;
		this.logger.info("Sort  ",this.criteria)
		this.service.get(Api.VESSEL, this.criteria).subscribe(res => { 
			this.logger.info('Vessel Res',res);
			this.vesselDataSource=res.contents;
			this.totalVesselRecords=res.totalRecords;
			if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
				this.paginator.pageIndex = 0;
			  }
		});
	} else
		this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,'warning');
}

openForm(row?: any): void{
	if(!this.addPermission && !row)
		return this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
	if(!this.editPermission && row)
		return this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
	const dailogRef =  this.dialog.open(VesselFormComponent, { data: row });
	dailogRef.afterClosed().subscribe(() => this.getVessels());
}


getStatusTypes() {
		this.service.get(Api.STATUS_TYPE_LIST).subscribe(res => {
		this.statusTypes.push({key: "", label: "Search by Status"});
		this.statusTypes.push(...res);
   });
}

public checkAllPermission(){
    const permissionCodes=[PermissionKey.VESSEL_MODULE_ADD_PERMISSION,PermissionKey.VESSEL_MODULE_DELETE_PERMISSION,
      PermissionKey.VESSEL_MODULE_EDIT_PERMISSION,PermissionKey.VESSEL_MODULE_VIEW_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VESSEL_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_ADD_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_VIEW_PERMISSION})?.show?true:false; 
 }

}